import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';

import {
  apolloErrorLink,
  apolloOperationNameLink,
  apolloRequestIdLink,
} from './links';

/**
 * There is no auth link and no token storage. The session lives in the
 * HttpOnly `dc_session` cookie, which the API sets on `.<slug>.daily-czech.dev`
 * so the app and API subdomains share it — `credentials: 'include'` is the
 * entire client side of authentication.
 *
 * No WebSocket link either: the API exposes no subscriptions.
 */
const httpLink = createHttpLink({
  uri: import.meta.env.VITE_DC_API_GQL_URL,
  credentials: 'include',
});

export const apolloClient = new ApolloClient({
  link: apolloErrorLink.concat(
    apolloRequestIdLink
      .concat(apolloOperationNameLink)
      .concat(httpLink),
  ),
  cache: new InMemoryCache(),
});
